import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Cart item interface
interface CartItem {
  id: string;
  title?: string;
  imgSrc?: string;
  price: number;
  rating?: number;
  reviews?: number;
  quantity: number;
  categories?: string;
}

// Cart state containing only items
interface CartState {
  items: CartItem[];
}

const LOCAL_STORAGE_KEY = "cartState";
const defaultCartItems: CartItem[] = [
  {
    id: "1",
    title: "Bloom Delight",
    imgSrc: "/images/product/popular/6.png",
    price: 16.0,
    quantity: 1,
    rating: 4.5,
    reviews: 26,
    categories: "Best sellers",
  },
  {
    id: "2",
    title: "Vibrant Pepper",
    imgSrc: "/images/product/popular/7.png",
    price: 6.0,
    quantity: 1,
    rating: 4.9,
    reviews: 25,
    categories: "Best sellers",
  },
  {
    id: "3",
    title: "Crisp Refresher",
    imgSrc: "/images/product/popular/8.png",
    price: 21.0,
    quantity: 1,
    rating: 4.6,
    reviews: 22,
    categories: "Best sellers",
  },
  {
    id: "4",
    title: "Crisp Leaf Luxury",
    imgSrc: "/images/product/popular/9.png",
    price: 24.0,
    quantity: 1,
    rating: 5.0,
    reviews: 24,
    categories: "Features",
  },
];
// Load cart from local storage
const loadCartFromLocalStorage = (): CartState => {
  if (typeof window !== "undefined") {
    try {
      const storedCart = localStorage.getItem(LOCAL_STORAGE_KEY);
      // Ensure storedCart is valid JSON and not an empty string or "undefined"
      if (storedCart && storedCart !== "undefined") {
        const parsedCart = JSON.parse(storedCart);
        if (Array.isArray(parsedCart)) {
          return { items: parsedCart }; // Return as expected CartState format
        }
      }else{
        return { items: defaultCartItems };
      }
    } catch (error) {
      console.log(error);
      return { items: defaultCartItems };
    }
  }
  return { items: defaultCartItems }; // Ensure a valid state even if localStorage fails
};


const initialState: CartState = loadCartFromLocalStorage();

// Helper functions to calculate total price & quantity
export const getTotalQuantity = (items: CartItem[]) => 
  items.reduce((total, item) => total + item.quantity, 0);

export const getTotalPrice = (items: CartItem[]) => 
  items.reduce((total, item) => total + item.price * item.quantity, 0);

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action: PayloadAction<CartItem>) => {
      const existingItem = state.items.find((item) => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += action.payload.quantity;
      } else {
        state.items.push(action.payload);
      }
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },

    addAllItems: (state, action: PayloadAction<CartItem[]>) => {

      console.log('action',action);
      
      // state.items = [...state.items, ...action.payload]; // Spread operator to avoid mutation
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },

    removeItem: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((item) => item.id !== action.payload);
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },

    updateQuantity: (state, action: PayloadAction<{ id: string; quantity: number }>) => {
      const item = state.items.find((item) => item.id === action.payload.id);
      if (item && action.payload.quantity > 0) {
        item.quantity = action.payload.quantity;
      }
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },

    clearCart: (state) => {
      state.items = [];
      localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(state.items));
    },
  },
});

export const { addItem, addAllItems, removeItem, updateQuantity, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
